import { IndicatorType } from '../constants/common'
import EMA from '../helpers/ema'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class ForceIndex extends Indicator<Attrs> {
  static type = IndicatorType.Fi
  static label = 'Force Index'

  fi: number[] = []
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (this.isComputeNecessary()) {
      this.fi = []
      const ema = new EMA(this.period)
      for (let i = 1; i < this.data.close.length; i++) {
        ema.add(((this.data.close[i] - this.data.close[i - 1]) * this.data.volume[i]) / 1000000)
        this.fi[i] = ema.value
      }
      this.lastValue = this.fi.last() ?? null
    }
    const { min, max } = this.fi.length > 0 ? this.computeVisibleMinMax(this.fi) : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    this.renderOversoldOverbought(context, this.fi, 1, 0, 0, 0, false)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 13,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `FORCE ${this.period}`
  }
}

export default ForceIndex
